import type { FC, ReactNode } from 'react';

import styles from './EmailSignatureEditorAddons.module.scss';

const EmailSignatureEditorAddonsBox = ({
  ref: forwardedRef,
  children,
}: { children: ReactNode } & {
  ref?: React.Ref<HTMLDivElement>;
}) => {
  return (
    <div className={styles['addons-box']} ref={forwardedRef}>
      {children}
    </div>
  );
};

const EmailSignatureEditorAddonsBoxHeader: FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  return <div className={styles['addons-box-header']}>{children}</div>;
};

const EmailSignatureEditorAddonsBoxHeaderContents: FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  return <div className={styles['addons-box-header-contents']}>{children}</div>;
};

const EmailSignatureEditorAddonsBoxBody: FC<React.PropsWithChildren<{ collapsed: boolean }>> = ({
  children,
  collapsed,
}) => {
  return (
    <div data-collapsed={collapsed.toString()} className={styles['addons-box-body']}>
      {children}
    </div>
  );
};

const EmailSignatureEditorAddonsBoxHeaderDivider: FC<React.PropsWithChildren<unknown>> = () => {
  return <div className={styles['addons-box-header-divider']} />;
};

export {
  EmailSignatureEditorAddonsBoxHeader,
  EmailSignatureEditorAddonsBoxHeaderContents,
  EmailSignatureEditorAddonsBox,
  EmailSignatureEditorAddonsBoxBody,
  EmailSignatureEditorAddonsBoxHeaderDivider,
};

EmailSignatureEditorAddonsBox.displayName = 'EmailSignatureEditorAddonsBox';
